export const initialState = {
  detail: null,
  error: null,
};
